var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638435760465,
    className: "icon",
    viewBox: "0 0 1054 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4332,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 205.859375,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.665413 824.614245a60.112101 60.112101 0 0 1 56.739078 0l259.783056 139.076995-49.842448-295.952713a60.353031 60.353031 0 0 1 16.985584-52.854076L993.837338 404.973958l-291.495503-43.156633a60.20245 60.20245 0 0 1-45.325006-33.308609L527.034952 60.323216l-130.011994 268.1855a60.20245 60.20245 0 0 1-45.355122 33.308609l-291.495503 43.126517 211.566888 209.940609c13.913723 13.823374 20.238142 33.519423 16.985584 52.854076L238.822124 963.69124l259.813173-139.076995z m28.369539 53.185356l-259.813173 139.046878a60.142217 60.142217 0 0 1-87.698616-63.183961l49.842448-295.952713-211.536771-209.910492a60.353031 60.353031 0 0 1 33.549539-102.485711l291.525619-43.126518 129.981877-268.185499a60.142217 60.142217 0 0 1 108.298154 0l129.981877 268.185499 291.525619 43.126518a60.262682 60.262682 0 0 1 33.549539 102.455594l-211.536771 209.940609 49.842448 295.952713a60.262682 60.262682 0 0 1-87.728732 63.183961L527.034952 877.799601z",
    fill: "#7F7F7F",
    "p-id": 4333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/collect.c31f0fa5dab915840ce0b850c270d6c4.svg";
export { ForwardRef as ReactComponent };